/* Amare Bakes coming-soon waitlist.
   Native POST only (Shopify's captcha script wraps the submit), so this file never calls
   form.submit() or fetch. It validates inline, writes ONE contact[tags] value (area, WhatsApp and the
   chosen language), keeps the submit button inactive until every field is valid, and shows the owner's
   confirmation. Without JS the form still posts. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Owner entry: bring the password field into view when it opens ---------- */
  (function () {
    var pw = document.querySelector('details.cs-pw');
    var pwInput = document.getElementById('cs-pw-input');
    if (!pw || !pwInput) return;
    function reveal(focus) {
      requestAnimationFrame(function () {
        var body = pw.querySelector('.cs-pw__body') || pwInput;
        body.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
        if (focus) pwInput.focus({ preventScroll: true });
      });
    }
    pw.addEventListener('toggle', function () { if (pw.open) reveal(true); });
    // opened by the server after a wrong password: the toggle event also fires on load, but settle again after late scripts
    if (pw.open) {
      var go = function () { reveal(true); };
      if (document.readyState === 'complete') setTimeout(go, 150);
      else window.addEventListener('load', function () { setTimeout(go, 150); });
    }
  })();

  var form = document.getElementById('amare-waitlist');
  if (!form) return;
  var i18n = {};
  try { i18n = JSON.parse(document.getElementById('cs-i18n').textContent); } catch (e) {}
  var E = i18n.errors || {};
  var KEY = 'amare-cs';

  function store(v) { try { if (v) sessionStorage.setItem(KEY, JSON.stringify(v)); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function load() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }

  function revealTop() {
    // keep the brand in view (logo + headline + card) when it fits; the card itself must always be fully visible
    var panel = document.getElementById('cs-panel');
    if (!panel) return;
    var y = innerWidth < 900 ? Math.max(0, panel.getBoundingClientRect().top + scrollY - 72) : 0;
    var card = document.getElementById('cs-success');
    if (card) {
      var r = card.getBoundingClientRect();
      var top = r.top + scrollY, bottom = r.bottom + scrollY;
      if (bottom + 16 > y + innerHeight) y = Math.max(y, Math.min(top - 16, bottom + 16 - innerHeight));
    }
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  }

  function showSuccess(el) {
    // the lede's "leave your details" line no longer applies once the visitor is on the list
    var cta = document.querySelector('.cs-lede__cta');
    if (cta) cta.hidden = true;
    var saved = load();
    var h = el.querySelector('[data-cs-heading]');
    var fn = String(saved.first || '').trim();
    if (h && fn && i18n.thanksNamed) h.textContent = i18n.thanksNamed.replace('%NAME%', fn);
    store(null);
    function focusHeading() {
      if (h && (!document.activeElement || document.activeElement === document.body)) h.focus({ preventScroll: true });
    }
    focusHeading();
    requestAnimationFrame(revealTop);
    // the #amare-waitlist jump and late storefront scripts can reset focus/scroll: settle once more after load
    function settle() { focusHeading(); revealTop(); }
    if (document.readyState === 'complete') setTimeout(settle, 150);
    else window.addEventListener('load', function () { setTimeout(settle, 150); });
  }

  /* ---------- Success (server-rendered, or captcha-path fallback) ---------- */
  var success = form.querySelector('[data-cs-success]');
  if (success) { showSuccess(success); return; }

  var hasServerError = !!form.querySelector('[data-cs-servererror], .is-invalid');
  var saved = load();
  // only a submit from the last few minutes counts, so an abandoned captcha cannot show a card later
  var fresh = saved.submitted && typeof saved.at === 'number' && Date.now() - saved.at >= 0 && Date.now() - saved.at < 10 * 60 * 1000;
  if (!hasServerError && fresh && location.hash === '#amare-waitlist' && !/customer_posted=/.test(location.search)) {
    var tpl = document.getElementById('cs-success-tpl');
    if (tpl && tpl.content) {
      form.textContent = '';
      form.appendChild(tpl.content.cloneNode(true));
      showSuccess(form.querySelector('[data-cs-success]'));
      return;
    }
  }

  /* ---------- Wire up ---------- */
  var $ = function (id) { return document.getElementById(id); };
  var inputs = { first: $('cs-first'), last: $('cs-last'), phone: $('cs-phone'), email: $('cs-email'), area: $('cs-area'), other: $('cs-other') };
  var langs = [$('cs-lang-en'), $('cs-lang-ar')];
  var ORDER = ['first', 'last', 'phone', 'email', 'area', 'other', 'lang'];
  var tags = form.querySelector('[data-cs-tags]');
  var status = $('cs-status');
  var btn = form.querySelector('[data-cs-submit]');
  var btnLabel = form.querySelector('[data-cs-submit-label]');
  var btnText = btnLabel ? btnLabel.textContent : '';
  var otherWrap = $('cs-other-wrap');
  var telControl = inputs.phone.parentNode;
  var touched = {};
  var busy = false;
  var pressing = false; // pointer is down on the submit button: don't reflow the form under it
  btn.addEventListener('pointerdown', function () { pressing = true; });
  ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
    btn.addEventListener(t, function () { setTimeout(function () { pressing = false; }, 400); });
  });

  // JS on: the visible controls stop posting raw values; the hidden fields carry the mapping.
  form.setAttribute('novalidate', '');
  // nothing is announced as invalid before the visitor has touched it: the empty select placeholder
  // would otherwise read as "invalid entry" (validate() switches this to "true" on a real error)
  Object.keys(inputs).forEach(function (k) {
    if (!inputs[k].hasAttribute('aria-invalid')) inputs[k].setAttribute('aria-invalid', 'false');
  });
  // WhatsApp only reaches the store through the JS-built tags, so it is required only when JS runs
  inputs.phone.required = true;
  inputs.area.removeAttribute('name');
  tags.name = 'contact[tags]';

  function langValue() {
    for (var i = 0; i < langs.length; i++) if (langs[i].checked) return langs[i].value;
    return '';
  }

  function areaValue() {
    var o = inputs.area.options[inputs.area.selectedIndex];
    return o && o.value ? (o.getAttribute('data-area') || '') : '';
  }

  /* ---------- WhatsApp ---------- */
  // Arabic-Indic and Persian digits -> ASCII; drop bidi marks that come with numbers pasted in RTL
  function asciiDigits(v) {
    return String(v || '')
      .replace(/[\u0660-\u0669]/g, function (d) { return String(d.charCodeAt(0) - 0x660); })
      .replace(/[\u06F0-\u06F9]/g, function (d) { return String(d.charCodeAt(0) - 0x6F0); })
      .replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '');
  }
  function normPhone(v) {
    var s = asciiDigits(v).replace(/[\s\-(). ]/g, '');
    if (!s) return null;
    if (/^00/.test(s)) s = '+' + s.slice(2);
    if (s.charAt(0) === '+') {
      if (/^\+9710?5\d{8}$/.test(s)) return '+9715' + s.slice(-8);
      if (/^\+971/.test(s)) return null;               // UAE, but not a mobile
      return /^\+[1-9]\d{6,14}$/.test(s) ? s : null;     // other countries, E.164
    }
    if (/^9715\d{8}$/.test(s)) return '+' + s;
    if (/^0?5\d{8}$/.test(s)) return '+971' + s.replace(/^0/, '');
    return null;
  }
  function uaeDisplay(e164) { return e164.replace(/^\+971(5\d)(\d{3})(\d{4})$/, '$1 $2 $3'); }
  // hide the +971 prefix when the number already carries its own start (+, 00, or a local 0)
  function syncIntl() { telControl.classList.toggle('is-intl', /^\s*(\+|0)/.test(asciiDigits(inputs.phone.value))); }

  /* ---------- Hidden fields ---------- */
  function clean(t) { return String(t).replace(/,/g, ' ').replace(/\s+/g, ' ').trim().slice(0, 240); }
  function sync() {
    var parts = ['waitlist'];
    var a = areaValue();
    if (a === '__other') {
      var typed = clean(inputs.other.value);
      parts.push('Area: ' + (typed ? typed + ' (other)' : 'Other'));
    } else if (a) {
      parts.push('Area: ' + clean(a));
    }
    var p = normPhone(inputs.phone.value);
    if (p) parts.push('WhatsApp: ' + p);
    parts.push('lang:' + (langValue() || i18n.lang || document.documentElement.lang || 'en'));
    parts.push('source:coming-soon');
    tags.value = parts.join(', ');
    refresh();
  }

  /* ---------- Validation ---------- */
  var icon = '<svg viewBox="0 0 16 16" aria-hidden="true"><circle cx="8" cy="8" r="7" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 4.3v4.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="8" cy="11.4" r=".95" fill="currentColor"/></svg>';
  var checks = {
    first: function (v) { return v.trim().length < 2 ? E.first : ''; },
    last: function (v) { return v.trim().length < 2 ? E.last : ''; },
    phone: function (v) { return !v.trim() ? E.phone_required : (normPhone(v) ? '' : E.phone_invalid); },
    email: function (v) { v = v.trim(); return !v ? E.email_required : (/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? '' : E.email_invalid); },
    area: function () { return areaValue() ? '' : E.area; },
    other: function (v) { return v.trim() ? '' : E.other; },
    lang: function () { return langValue() ? '' : E.lang; }
  };
  function validate(k, show) {
    var el = k === 'lang' ? langs[0] : inputs[k];
    if (el.disabled) return true;
    var msg = checks[k](el.value) || '';
    if (show) {
      var field = el.closest('.cs-field');
      var err = $('cs-e-' + k);
      field.classList.toggle('is-invalid', !!msg);
      (k === 'lang' ? langs : [el]).forEach(function (x) { x.setAttribute('aria-invalid', msg ? 'true' : 'false'); });
      if (msg) {
        err.innerHTML = icon;
        var span = document.createElement('span');
        span.textContent = msg;
        err.appendChild(span);
      } else {
        err.textContent = '';
      }
    }
    return !msg;
  }

  Object.keys(inputs).forEach(function (k) {
    var el = inputs[k];
    el.addEventListener('blur', function () {
      if (el.value.trim()) touched[k] = true;
      if (k === 'phone') {
        var n = normPhone(el.value);
        if (n && /^\+9715/.test(n)) el.value = uaeDisplay(n);
        syncIntl();
      }
      if (touched[k] && !pressing) {
        var wasInvalid = el.getAttribute('aria-invalid') === 'true';
        if (!validate(k, true) && !wasInvalid) status.textContent = checks[k](el.value) || '';
      }
      sync();
    });
    el.addEventListener('input', function () {
      if (k === 'phone') {
        var fixed = asciiDigits(el.value);
        if (fixed !== el.value) {
          var at = el.selectionStart, lost = el.value.length - fixed.length;
          el.value = fixed;
          try { el.setSelectionRange(Math.max(0, at - lost), Math.max(0, at - lost)); } catch (e) {}
        }
        syncIntl();
      }
      if (touched[k]) validate(k, true);
      sync();
    });
  });

  function syncOther(focus) {
    var open = areaValue() === '__other';
    otherWrap.classList.toggle('is-open', open);
    otherWrap.toggleAttribute('inert', !open); // closed: out of the accessibility tree and the tab order
    inputs.other.disabled = !open;
    inputs.other.required = open;
    if (!open) {
      inputs.other.value = '';
      inputs.other.closest('.cs-field').classList.remove('is-invalid');
      $('cs-e-other').textContent = '';
      touched.other = false;
    } else if (focus) {
      setTimeout(function () { inputs.other.focus(); }, 60);
    }
  }
  inputs.area.addEventListener('change', function () {
    touched.area = true;
    validate('area', true);
    syncOther(true);
    sync();
  });
  langs.forEach(function (r) {
    r.addEventListener('change', function () {
      touched.lang = true;
      validate('lang', true);
      sync();
    });
  });

  /* ---------- Submit button: inactive until every field is valid ----------
     aria-disabled (not disabled) keeps it focusable and clickable: a click on the inactive button
     is stopped by the submit check below, which then points at the missing fields. */
  function complete() {
    for (var i = 0; i < ORDER.length; i++) if (!validate(ORDER[i], false)) return false;
    return true;
  }
  function refresh() {
    if (busy) return;
    var ok = complete();
    btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    if (ok) btn.removeAttribute('aria-describedby');
    else btn.setAttribute('aria-describedby', 'cs-incomplete');
  }
  // browser autofill does not always fire input events, so look again every so often while the page is open
  setInterval(function () { if (!document.hidden) sync(); }, 800);

  /* ---------- Restore after a server-side error ---------- */
  if (hasServerError && (saved.first || saved.last || saved.phone || saved.area)) {
    if (saved.first) inputs.first.value = saved.first;
    if (saved.last) inputs.last.value = saved.last;
    langs.forEach(function (r) { r.checked = r.value === saved.lang; });
    if (saved.phone) inputs.phone.value = saved.phone;
    if (saved.area) {
      for (var i = 0; i < inputs.area.options.length; i++) {
        if (inputs.area.options[i].getAttribute('data-area') === saved.area) { inputs.area.selectedIndex = i; break; }
      }
      syncOther(false);
      if (saved.other) inputs.other.value = saved.other;
    }
    syncIntl();
    store({ first: saved.first, last: saved.last, phone: saved.phone, area: saved.area, other: saved.other, lang: saved.lang });
    ORDER.forEach(function (k) { touched[k] = true; });
    var bad = form.querySelector('.is-invalid .cs-input') || inputs.email;
    bad.focus({ preventScroll: true });
    requestAnimationFrame(function () { bad.scrollIntoView({ block: 'center', behavior: 'auto' }); });
  }
  syncIntl();
  sync();

  /* ---------- Submit ----------
     Capture phase on window so an invalid form is stopped before anything else sees it.
     A valid submit is never blocked, so Shopify's captcha resubmission always goes through. */
  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    if (busy) return;
    var bad = [];
    ORDER.forEach(function (k) {
      touched[k] = true;
      if (!validate(k, true)) bad.push(k);
    });
    if (bad.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      status.textContent = bad.length === 1 ? i18n.statusOne : String(i18n.statusMany || '').replace('%N%', bad.length);
      (bad[0] === 'lang' ? langs[0] : inputs[bad[0]]).focus();
      return;
    }
    status.textContent = '';
    sync();
    store({ first: inputs.first.value.trim(), last: inputs.last.value.trim(), phone: inputs.phone.value.trim(), area: areaValue(), other: inputs.other.value.trim(), lang: langValue(), submitted: true, at: Date.now() });
    busy = true;
    btn.setAttribute('aria-busy', 'true');
    if (btnLabel && i18n.submitting) btnLabel.textContent = i18n.submitting;
    setTimeout(release, 8000); // never leave the button stuck if the page does not navigate
  }, true);

  function release() {
    busy = false;
    btn.removeAttribute('aria-busy');
    if (btnLabel) btnLabel.textContent = btnText;
    refresh();
  }

  // swallow extra taps while the first submit is on its way (does not touch programmatic resubmits)
  btn.addEventListener('click', function (e) { if (busy) e.preventDefault(); });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) release();
  });
})();
